module.exports = __webpack_public_path__ + "static/img/product1.3063515.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/yiBrand/white/product1.png
// module id = 2khq
// module chunks = 0